import "./fcopel/style.css";
import { Sectionpd} from "../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "./padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Fundaffemg() {
  return (
    <main>
        <Helmet>
            <title>FUNDAFFEMG - Gabriel Barbosa</title>
            <meta name="description" content="Desenvolvi de forma independente o site destinado a operadora de plano de saúde para os associados da Fundação AFFEMG, criando um portal robusto para a interação e acesso à informações importantes para os seus integrantes. O site foi projetado para ser uma plataforma centralizada, com blogs informativos sobre saúde, detalhes sobre os planos de saúde oferecidos pela operadora, acesso a documentos e uma busca avançada para facilitar a navegação e a localização de informações de forma eficiente." />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/banner_fundaffemg.jpg'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>FUNDAFFEMG</h1>
                            <Flexmidbanner>
                                <a href="https://elos.org.br/elosprev" target="_blank" rel="noreferrer">fundaffemg.com.br</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//FRONT-END + INTEGRAÇÃO + WORDPRESS + HOSPEDAGEM</Tags>
                            <Paragrafoint>Desenvolvi de forma independente o site destinado a operadora de plano de saúde para os associados da Fundação AFFEMG, criando um portal robusto para a interação e acesso à informações importantes para os seus integrantes. O site foi projetado para ser uma plataforma centralizada, com blogs informativos sobre saúde, detalhes sobre os planos de saúde oferecidos pela operadora, acesso a documentos e uma busca avançada para facilitar a navegação e a localização de informações de forma eficiente.</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/fundaffemgsobre.png" alt="Fundaffemg" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Utilizando HTML, CSS e JavaScript, desenvolvi o projeto com foco na acessibilidade em diversos formatos de dispositivos. A estrutura do site foi desenvolvida com foco na usabilidade, permitindo que os usuários navegassem facilmente entre as diversas seções, e que a operadora pudesse fornecer informações claras e de fácil acesso. Esse projeto foi criado com a intenção de proporcionar uma experiência do usuário otimizada e sem falhas, atendendo às necessidades específicas do cliente e oferecendo uma ferramenta eficaz para a gestão do conteúdo e interação com seus usuários. </Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/fundaffemgsempre.png" alt="Fundaffemg Sempre" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Além disso, realizei a reestruturação do mecanismo de busca com PHP, implementando uma versão mais avançada e precisa, com foco em melhorar a eficiência e a relevância dos resultados. Também fui encarregado de corrigir e otimizar os formulários de contato e a integração com o CRM, também fazendo uso de PHP para garantir uma gestão mais eficiente e organizada das informações dos usuários.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/elosprev" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>ELOS Previdência</h3>
                                <span>//FRONT-END + RESTRUTURAÇÃO UX/UI</span>
                            </Btnnav>
                        </Link>
                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/elosprev" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/sharknarguiles" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/sharknarguiles" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>SHARK NARGUILES</h3>
                                <span>//E-COMMERCE + BANCO DE DADOS + INTEGRAÇÃO</span>
                            </Btnnav>
                        </Link> 
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default Fundaffemg;